import { AppState } from "../app.state";

export const getNotification = (state: AppState) => state.notification.notification;
